import { useContext } from "react";
import { Card, Row, Col, Form } from "react-bootstrap";
import { RiMailLine, RiMessage2Line, RiNotificationLine } from "react-icons/ri";
import { AuthContext } from "../../states/AuthContext";

export default function DeliveryMethods() {
  const { userProfileData } = useContext(AuthContext);
  return (
    <Card className="ap-card delivery-card">

      {/* HEADER */}
      <div className="section-header">
        <div className="step mb-0">1</div>
        <div>
          <h6>Delivery Methods</h6>
          {/* <p>Choose how you want to receive alerts.</p> */}
        </div>
      </div>

      <Row className="g-3 mt-2">

        {/* EMAIL */}
        <Col lg={4} md={6}>
          <div className="method-box  ">

            {/* <Form.Check className="check" checked /> */}

            <div className="icon email">
              <RiMailLine />
            </div>

            <div className="content">
              <h6>Email Notifications</h6>
              <p>Receive alerts via email</p>
              <span className="text-wrap text-break ">{userProfileData?.email}</span>
            </div>

          </div>
        </Col>

        {/* SMS */}
        <Col lg={4} md={6}>
          <div className="method-box">

            {/* <Form.Check className="check" checked /> */}

            <div className="icon sms">
              <RiMessage2Line />
            </div>

            <div className="content">
              <h6>SMS Notifications</h6>
              <p>Receive alerts via text</p>
              <span>{userProfileData?.phoneNumber}</span>
              <small>Carrier fees may apply</small>
            </div>

          </div>
        </Col>

        {/* IN APP */}
        <Col lg={4} md={6}>
          <div className="method-box">

            {/* <Form.Check className="check" checked /> */}

            <div className="icon app">
              <RiNotificationLine />
            </div>

            <div className="content">
              <h6>In-App Notifications</h6>
              <p>Receive alerts in the app</p>
              <span className="green">Always enabled</span>
            </div>

          </div>
        </Col>

      </Row>
    </Card>
  );
}